<div class="titlebar">
  <h3>{{ "Template.SupplierProductSearchComponent.label_title" | translate }}</h3>
</div>

<div class="mb-2">
  <input type="text" class="form-control" id="search-product" placeholder="{{ 'Template.SupplierProductSearchComponent.placeholder_ean' | translate }}" [(ngModel)]="ean" />
  <button class="btn btn-primary mt-2" type="submit" (click)="reload()" [disabled]="loading">{{ "Template.SupplierProductSearchComponent.btn_search" | translate }}</button>
</div>

@if (loading) {
  <div class="mt-3 p-4">
    <fa-icon icon="spinner" animation="spin" size="3x"></fa-icon>
  </div>
}

@if (!loading && !supplierProducts?.length) {
  <div class="mt-3 alert alert-info">{{ "Template.SupplierProductSearchComponent.text_noSearchResults" | translate }}</div>
}

@if (supplierProducts && supplierProducts.length) {
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col" class="col-md-2 col-sm-1">
          {{ "Template.SupplierProductSearchComponent.label_supplierPartyName" | translate }}
        </th>
        <th scope="col" class="col-md-2 col-sm-1">
          {{ "Template.SupplierProductSearchComponent.label_description" | translate }}
        </th>
        <th scope="col" class="col-md-2">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      @for (product of supplierProducts; track product) {
        <tr>
          <td>{{ product.supplier?.attributes?.['NAME'] }}</td>
          <td>{{ product.description }}</td>
          <td class="text-end align-middle">
            <a [routerLink]="['/app', 'admin', 'supplier-product', product.id]" class="btn btn-secondary">
              {{ "Template.SupplierProductSearchComponent.btn_details" | translate }}
              <fa-icon icon="chevron-right"></fa-icon>
            </a>
          </td>
        </tr>
      }
    </tbody>
  </table>
}
